import { render, staticRenderFns } from "./TemperatureDetailBlock.vue?vue&type=template&id=20c24de2&scoped=true&"
import script from "./TemperatureDetailBlock.vue?vue&type=script&lang=js&"
export * from "./TemperatureDetailBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c24de2",
  null
  
)

export default component.exports